import FlavorDecompositionTable from './FlavorDecompositionTable';
export default FlavorDecompositionTable;